import { render, staticRenderFns } from "./UsertypeCreate.vue?vue&type=template&id=04c604c6&scoped=true"
import script from "./UsertypeCreate.vue?vue&type=script&lang=js"
export * from "./UsertypeCreate.vue?vue&type=script&lang=js"
import style0 from "./UsertypeCreate.vue?vue&type=style&index=0&id=04c604c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c604c6",
  null
  
)

export default component.exports